 <svg
        class="animated-svg"
        [attr.viewBox]="'0 0 ' + width() + ' ' + (height() + 120)"
        preserveAspectRatio="xMidYMin meet">
        
        <g shadow-type-2 [height]="height()"/>
        <g wall-type-9 [height]="height()"></g>
        
        <g roof-type-9/>
        <g outline />
        <g window-type-2 [height]="height()" [windowMargin]="0"/>

</svg>